import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEOHead from "@/components/seo/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Removed complex console statement for security;
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <SEOHead
        title="Page Not Found"
        description="The Meduler page you requested could not be found."
        canonicalUrl="https://www.meduler.com/404"
      />
      <main className="max-w-2xl text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-purple-600 mb-3">404</p>
        <h1 className="text-4xl font-bold mb-4 text-gray-900">Page not found</h1>
        <p className="text-lg text-gray-600 mb-8">
          That Meduler page does not exist. Use the public guides below to find medication
          management features, caregiver information, pricing, privacy details, and support.
        </p>
        <nav aria-label="Recovery links" className="flex flex-wrap justify-center gap-4">
          <Link to="/" className="text-purple-700 underline">Home</Link>
          <Link to="/features" className="text-purple-700 underline">Features</Link>
          <Link to="/caregivers" className="text-purple-700 underline">Caregivers</Link>
          <Link to="/pricing" className="text-purple-700 underline">Pricing</Link>
          <Link to="/about" className="text-purple-700 underline">About</Link>
          <a href="/sitemap.xml" className="text-purple-700 underline">Sitemap</a>
          <a href="/llms.txt" className="text-purple-700 underline">Agent guide</a>
          <Link to="/contact" className="text-purple-700 underline">Contact</Link>
        </nav>
      </main>
    </div>
  );
};

export default NotFound;
